module.exports = __webpack_public_path__ + "img/s4ucash.f01e0fa0.svg";